// src/pages/PartnerShipApplication/RenderDetailsModal.jsx
import React from 'react'
import Modal from "../../components/UI/Modal";
import CloseIcon from '@mui/icons-material/Close';
import SettingIconBlock from '../../components/Button/SettingIconBlock';
import { cancellationStatus } from '../../actions';
import { useDispatch } from 'react-redux';
import { formatDate } from './../../components/FormDate';
import DetailsGrid from '../../components/DetailsGrid';
import StatusTimeline from '../../components/StatusTimeline';

const RenderDetailsModal = ({
    roleChangeRequestObj,
    applicationDetailModal,
    handleClose,
    handleDeleteById,
    typeModal,
    handleUpdateStatus,
    setType,
    role,
    userDetails
}) => {
    const dispatch = useDispatch()
    if (!roleChangeRequestObj) return null

    const handleChangeOrderStatus = (e) => { setType(e.target.value) }
    const handleCancellationStatus = (text, type) => {
        const payload = { text, type }
        dispatch(cancellationStatus("application", roleChangeRequestObj._id, "status", payload))
    }
    const onSubmit = (id) => { handleUpdateStatus(id) }

    return (
        <Modal
            show={applicationDetailModal}
            handleClose={handleClose}
            modalTitle="Детали заявки на смену роли"
            size="lg"
        >
            {typeModal === "settingModal" ? (
                <StatusTimeline
                    items={roleChangeRequestObj.status || []}
                    canCancel={role === "superAdmin"}
                    cancelIcon={<SettingIconBlock icon={<CloseIcon />} top="0" inline />}
                    onCancel={(s) => handleCancellationStatus(s.text, s.type)}
                    onChangeSelect={handleChangeOrderStatus}
                    onSubmit={() => onSubmit(roleChangeRequestObj._id)}
                    format={(d) => formatDate(d)}
                    confirmText="Подтвердить"
                    selectPlaceholder="Выбрать статус"
                />
            ) : (
                <DetailsGrid
                    userDetails={userDetails}
                    roleChangeRequestObj={roleChangeRequestObj}
                    onDelete={handleDeleteById}
                />
            )}
        </Modal>
    )
}

export default RenderDetailsModal
